var map = {
	"./artist.jpg": "f348",
	"./artist.mp4": "5216",
	"./artist.webm": "4afc",
	"./band.jpg": "cd2d",
	"./band.mp4": "6b8e",
	"./band.webm": "9c9d",
	"./black.jpg": "9533",
	"./contact.jpg": "d065",
	"./contact.mp4": "ba41",
	"./contact.webm": "2457",
	"./dj.jpg": "72b7",
	"./dj.mp4": "9785",
	"./dj.webm": "4e9a",
	"./musikquiz.jpg": "0946",
	"./musikquiz.mp4": "f793",
	"./musikquiz.webm": "8ac2",
	"./party.jpg": "a2fd",
	"./party.mp4": "4c65",
	"./party.webm": "1ed9",
	"./scen.jpg": "3fb7",
	"./scen.mp4": "e8af",
	"./scen.webm": "a4d3b",
	"./startsida.jpg": "b2eb",
	"./startsida.mp4": "b647",
	"./startsida.webm": "dc0a",
	"./trubadur.jpg": "df4c",
	"./trubadur.mp4": "86f3",
	"./trubadur.webm": "4ef0",
	"./upcoming.jpg": "1064",
	"./upcoming.mp4": "24c0",
	"./upcoming.webm": "ee41"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a9f";